<template>
  <div>
    <v-dialog v-model="contractDialog" max-width="800px" lazy>
      <v-card class="px-3 pt-2">
        <v-card-title class="py-2">
          <v-layout align-center justify-end row fill-height>
            <div class="headline font-weight-bold mx-auto">
              Contratos da Usina
            </div>
          </v-layout>
          <v-icon @click="contractDialog = false" class="ml-auto" color="orange"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="ma-0 pa-0">
          <v-data-table
            :headers="headers"
            :hide-actions="true"
            :items="contracts"
            class="elevation-1"
          >
            <template v-slot:no-data>
              <p class="text-md-center" v-if="loadingContracts">
                <v-progress-circular
                  color="purple"
                  indeterminate
                  size="18"
                ></v-progress-circular>
                CARREGANDO CONTRATOS
              </p>
              <p class="text-md-center" v-else>USINA SEM CONTRATOS</p>
            </template>
            <template v-slot:items="props">
              <td class="py-0">
                <a :href="props.item.fileUrl" target="_blank"
                  >{{ props.item.fileName }}
                  <v-icon size="18">mdi-open-in-new</v-icon>
                </a>
              </td>
              <td class="py-0 text-xs-right">{{ props.item.created_at }}</td>
              <td class="py-0 text-xs-right">{{ props.item.type }}</td>
              <td class="py-0 text-xs-right">
                <v-btn
                  v-if="props.item.canDelete"
                  icon
                  @click="deleteContract(props.item.id, props.item.fileName)"
                >
                  <v-progress-circular
                    v-if="loadingDelete && deletingContract === props.item.id"
                    indeterminate
                    color="red"
                    size="18"
                  ></v-progress-circular>
                  <v-icon v-else color="red">mdi-delete</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="pt-3 mx-0">
          <div class="ml-auto">
            <v-layout align-center justify-end row>
              <v-autocomplete
                v-model="contract_type"
                :items="contract_types"
                label="Tipo de Contrato"
                class="purple-input mr-2"
                item-text="name"
                return-object
              />
              <v-btn
                color="primary"
                text
                :disabled="loadingUpload || !contract_type"
                @click="pickFiles()"
              >
                <v-progress-circular
                  v-if="loadingUpload"
                  indeterminate
                  color="white"
                  size="18"
                  class="mr-2"
                />
                <v-icon v-else class="mr-2">mdi-upload</v-icon>ADICIONAR
                CONTRATO
              </v-btn>
            </v-layout>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
    <input
      accept="application/pdf"
      type="file"
      ref="contract"
      style="display: none"
      multiple
      @change="pickedFile($event)"
    />
  </div>
</template>

<script>
import {
  uploadContract,
  deleteContract,
  getContracts,
} from "@/services/powerplants.js";
import moment from "moment";
import { mapState } from "vuex";
import { getPermission } from "../../services/permissions";

export default {
  data() {
    return {
      powerPlantId: null,
      powerPlantStatus: null,
      headers: [
        { text: "Arquivo", sortable: false },
        { text: "Salvo em", sortable: false, align: "center", width: "1%" },
        { text: "Tipo", sortable: false, align: "center", width: "1%" },
        { text: "Ações", sortable: false, align: "center", width: "1%" },
      ],
      contractDialog: false,
      contract_type: null,
      contract_types: [
        { type: "commercial", name: "Comercial" },
        { type: "comodate", name: "Comodato" },
        { type: "additive", name: "Aditivo" },
        { type: "location", name: "Locação" },
        { type: "variable_remuneration", name: "O&M" },
        { type: "cancellation", name: "Distrato" },
        { type: "others", name: "Outros" },
      ],
      contracts: [],
      color: "",
      snackMessage: "",
      snackbar: false,
      loadingContracts: false,
      loadingUpload: false,
      loadingDelete: false,
      deletingContract: null,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  watch: {
    powerPlantId() {
      this.contracts = [];
      this.loadContracts();
    },
  },
  methods: {
    showContractModal(id, status) {
      this.powerPlantId = id;
      this.powerPlantStatus = status;
      this.contractDialog = true;
    },
    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    pickFiles() {
      this.$refs.contract.click();
    },
    async pickedFile(event) {
      const files = event.target.files;
      const type = this.contract_type?.type;

      if (!this.powerPlantId || this.powerPlantId === "") {
        this.snack("O ID da usina precisa ser informado", "error");
        return;
      }

      this.loadingUpload = true;
      try {
        for (const file of files) {
          if (file.size < 512) {
            this.snack(`Arquivo o arquivo "${file.name}" é inválido`, "error");
            continue;
          }

          if (
            this.contracts.some((contract) => contract.fileName === file.name)
          ) {
            this.snack(
              `Arquivo o arquivo "${file.name}" já cadastrado`,
              "error",
            );
            continue;
          }

          const data = {
            powerPlantId: this.powerPlantId,
            status: this.powerPlantStatus,
            type: type,
            file: file,
          };
          const result = await uploadContract(data);
          if (result.fileUrl) {
            this.contracts.push({
              fileName: file.name,
              fileUrl: result.fileUrl,
              created_at: moment(new Date()).format("DD/MM/YYYY"),
              type: this.mapContractType(type),
              id: result.id,
              canDelete: true,
            });
          } else {
            this.snack(`Erro ao adicionar o arquivo ${file.name}`, "error");
            this.loadingUpload = false;
          }
        }
        this.loadingUpload = false;
        this.$refs.contract.value = null;
      } catch (error) {
        this.snack("Erro ao adicionar contrato", "error");
        console.error(error);
        this.$refs.contract.value = null;
        this.loadingUpload = false;
      }
    },
    async deleteContract(id) {
      this.deletingContract = id;
      this.loadingDelete = true;

      try {
        const permission = await getPermission("delete_contract", this.user.id);

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          this.showDeleteModal = false;
          return false;
        }
      } catch (err) {
        this.showDeleteModal = false;
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      try {
        await deleteContract(this.powerPlantId, id);
        this.contracts = this.contracts.filter(
          (contract) => contract.id !== id,
        );
        this.snack("Contrato excluído com sucesso", "success");
        this.deletingContract = null;
        this.loadingDelete = false;
      } catch (error) {
        this.snack("Erro ao excluir contrato", "error");
        console.error(error);
        this.deletingContract = null;
        this.loadingDelete = false;
      }
    },
    async loadContracts() {
      if (!this.powerPlantId) {
        return;
      }
      this.loadingContracts = true;
      try {
        const result = await getContracts(this.powerPlantId);
        if (result && result.length > 0) {
          for (const contract of result) {
            this.contracts.push({
              fileName: contract.file_name || contract.id,
              fileUrl: contract.url,
              created_at: contract.created_at
                ? moment(contract.created_at.toDate()).format("DD/MM/YYYY")
                : "",
              type: this.mapContractType(contract.type),
              canDelete: true,
              id: contract.id,
            });
          }
        }
        this.loadingContracts = false;
      } catch (error) {
        this.snack("Erro ao carregar contratos", "error");
        console.error(error);
        this.loadingContracts = false;
      }
    },
    mapContractType(type) {
      return (
        this.contract_types.find((contract) => contract.type === type)?.name ||
        type
      );
    },
  },
};
</script>
